<script setup>
/*
 * Én delvurdering. Emnet er et FELT og ikke haardkodet — det er derfor
 * der kan laves en stoej-vurdering eller en batteritid-vurdering uden at
 * der skal en ny bloktype til.
 */
import { sanitizeHtml } from '@/Utils/sanitize';
import { computed } from 'vue';

const props = defineProps({ data: { type: Object, required: true } });

const html = computed(() => sanitizeHtml(props.data.tekst || ''));
const procent = computed(() => (props.data.score ? (Number(props.data.score) / 5) * 100 : 0));
</script>

<template>
    <div class="delvurdering">
        <div class="d-flex align-items-baseline gap-2 mb-2">
            <h3 class="h6 mb-0">{{ data.emne }}</h3>
            <span v-if="data.score" class="badge bg-primary">{{ data.score }} / 5</span>
        </div>

        <div v-if="data.score" class="progress mb-2" style="height: .5rem" role="img"
             :aria-label="`${data.emne}: ${data.score} ud af 5`">
            <div class="progress-bar" :style="{ width: procent + '%' }"></div>
        </div>

        <div v-if="html" v-html="html"></div>
    </div>
</template>
